const useListColumns = () => {
  return [
    {
      Header: "Name",
      accessor: "name",
    },
    {
      Header: "Artist",
      accessor: "artist",
    },
    {
      Header: "Type",
      accessor: "projectType",
      disableGlobalFilter: true,
    },
    {
      Header: "Listing Type",
      accessor: "listingType",
      disableGlobalFilter: true,
    },
    {
      Header: "Network",
      accessor: "network",
      disableGlobalFilter: true,
    },
    {
      Header: "Status",
      accessor: "status",
      disableGlobalFilter: true,
    },
    {
      Header: "Featured",
      accessor: "featured",
      disableGlobalFilter: true,
    },
    {
      Header: "Banned",
      accessor: "banned",
      disableGlobalFilter: true,
    },
    {
      Header: "Created At",
      accessor: "createdAt",
      disableGlobalFilter: true,
      sortType: (rowA: any, rowB: any) => rowA.original._createdAtTs - rowB.original._createdAtTs,
    },
    {
      Header: "",
      accessor: "actions",
      disableSortBy: true,
      disableGlobalFilter: true,
    },
  ];
};

export default useListColumns;
